import axios from 'axios';

// const baseURL = "http://sm.heinsohn.com.co:8088/api/v1/";
// const baseURL = 'https://famedicips.com.co/api/v1/';
// const baseURL = 'http://sm.heinsohn.com.co:8089/api/v1/';
const baseURL = 'https://api.famedicips.com.co/api/v1/';

const axiosInstance = axios.create({
  baseURL,
});

export default axiosInstance;
